<div class="login-container">
  <div class="form-area">
    <img class="logo-mobile" alt="Logo Mobile" />
    <router-outlet></router-outlet>
  </div>
  <div class="image-area background">
    <img class="logo" />
  </div>
</div>
